module.exports = __webpack_public_path__ + "media/zsiraf_m.c966b98a.mp3";